export const headCells = [
  {
    id: "recId",
    numeric: false,
    disablePadding: false,
    label: "Recruitment ID",
    width: "120",
  },

  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Received",
    width: "140",
  },

  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Candidate Name",
    width: "180",
  },

  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
    width: "220",
  },

  {
    id: "contactNumber",
    numeric: false,
    disablePadding: false,
    label: "Telephone",
    width: "140",
  },

  {
    id: "gender",
    numeric: false,
    disablePadding: false,
    label: "Gender",
    width: "100",
  },

  {
    id: "nationality",
    numeric: false,
    disablePadding: false,
    label: "Nationality",
    width: "140",
  },

  {
    id: "language",
    numeric: false,
    disablePadding: false,
    label: "Language",
    width: "140",
  },
  {
    id: "dialect",
    numeric: false,
    disablePadding: false,
    label: "Dialect",
    width: "140",
  },
  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
    width: "140",
  },

  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "Action",
    width: "120",
  },
];
